function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;
function pug_style(r){if(!r)return"";if("object"==typeof r){var t="";for(var e in r)pug_has_own_property.call(r,e)&&(t=t+e+":"+r[e]+";");return t}return r+""}function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Date, comments, d1, d2, distance, i18n, isEmoji, isNoMoreComments, moment, peerAuthoring) {
      if (comments.length === 0) {
pug_html = pug_html + "\u003Cp class=\"block-h-lg text-lg text-center\" id=\"social-view-no-comments\"\u003E" + (pug_escape(null == (pug_interp = i18n("social.be-first")) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
}
else {
var d1, d2, distance = 1000 * 60 * 5;
pug_html = pug_html + "\u003Cul class=\"clearfix\"\u003E";
// iterate comments 
;(function(){
  var $$obj = comments ;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var comment = $$obj[i];
d2 = new Date(comment.timestamp)
if (!d1 || moment(d1).diff(d2) > distance) {
d1 = d2;
pug_html = pug_html + "\u003Cli class=\"time text-center text-sm\"\u003E\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = moment(comment.timestamp).format("ddd, DD MMM")) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E" + (pug_escape(null == (pug_interp = moment(comment.timestamp).format(" h:mm")) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
}
pug_html = pug_html + "\u003Cli" + (pug_attr("class", pug_classes(["comment",[
          comment.isFromCurrentLearner ? "pull-right is-learner" : "pull-left",
          comment.likes > 0 ? "has-likes" : "no-likes",
          comment.isLikedByLearner ? "is-learner-liked" : "",
          comment.isFlaggedByLearner ? "is-learner-flagged" : ""
        ]], [false,true]), false, true)+pug_attr("style", pug_style(i < 5 ? `transition-delay: ${(i + 1) * 100}ms` : ""), true, true)) + "\u003E\u003Cdiv class=\"comment-label clearfix\"\u003E";
if (!comment.isFromCurrentLearner) {
pug_html = pug_html + "\u003Cspan class=\"comment-author\"\u003E" + (pug_escape(null == (pug_interp = comment.author) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E&ensp;";
}
if (!peerAuthoring) {
pug_html = pug_html + "\u003Cspan" + (" class=\"comment-action comment-like\""+pug_attr("data-id", comment.id, true, true)) + "\u003E\u003Cspan class=\"icon icon-heart\"\u003E\u003C\u002Fspan\u003E&nbsp;" + (pug_escape(null == (pug_interp = comment.likes || 0) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (!peerAuthoring) {
pug_html = pug_html + "\u003Cdiv class=\"comment-toggle-action clearfix\"\u003E";
if (comment.isFromCurrentLearner) {
pug_html = pug_html + "\u003Cspan" + (" class=\"comment-action comment-delete\""+pug_attr("data-id", comment.id, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = i18n("social.delete")) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"comment-action comment-cancel icon icon-close\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan" + (" class=\"comment-action comment-flag\""+pug_attr("data-id", comment.id, true, true)) + "\u003E\u003Cspan class=\"icon icon-flag\"\u003E\u003C\u002Fspan\u003E&nbsp;";
if (comment.isFlaggedByLearner) {
pug_html = pug_html + (pug_escape(null == (pug_interp = i18n("social.reported")) ? "" : pug_interp));
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = i18n("social.report")) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fspan\u003E\u003Cspan class=\"comment-action comment-cancel icon icon-close\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cp class=\"block-md comment-message text-md\"\u003E";
if (isEmoji(comment.message)) {
pug_html = pug_html + "\u003Cspan class=\"emoji\"\u003E" + (pug_escape(null == (pug_interp = comment.message) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = comment.message) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fp\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var comment = $$obj[i];
d2 = new Date(comment.timestamp)
if (!d1 || moment(d1).diff(d2) > distance) {
d1 = d2;
pug_html = pug_html + "\u003Cli class=\"time text-center text-sm\"\u003E\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = moment(comment.timestamp).format("ddd, DD MMM")) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E" + (pug_escape(null == (pug_interp = moment(comment.timestamp).format(" h:mm")) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
}
pug_html = pug_html + "\u003Cli" + (pug_attr("class", pug_classes(["comment",[
          comment.isFromCurrentLearner ? "pull-right is-learner" : "pull-left",
          comment.likes > 0 ? "has-likes" : "no-likes",
          comment.isLikedByLearner ? "is-learner-liked" : "",
          comment.isFlaggedByLearner ? "is-learner-flagged" : ""
        ]], [false,true]), false, true)+pug_attr("style", pug_style(i < 5 ? `transition-delay: ${(i + 1) * 100}ms` : ""), true, true)) + "\u003E\u003Cdiv class=\"comment-label clearfix\"\u003E";
if (!comment.isFromCurrentLearner) {
pug_html = pug_html + "\u003Cspan class=\"comment-author\"\u003E" + (pug_escape(null == (pug_interp = comment.author) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E&ensp;";
}
if (!peerAuthoring) {
pug_html = pug_html + "\u003Cspan" + (" class=\"comment-action comment-like\""+pug_attr("data-id", comment.id, true, true)) + "\u003E\u003Cspan class=\"icon icon-heart\"\u003E\u003C\u002Fspan\u003E&nbsp;" + (pug_escape(null == (pug_interp = comment.likes || 0) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (!peerAuthoring) {
pug_html = pug_html + "\u003Cdiv class=\"comment-toggle-action clearfix\"\u003E";
if (comment.isFromCurrentLearner) {
pug_html = pug_html + "\u003Cspan" + (" class=\"comment-action comment-delete\""+pug_attr("data-id", comment.id, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = i18n("social.delete")) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"comment-action comment-cancel icon icon-close\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan" + (" class=\"comment-action comment-flag\""+pug_attr("data-id", comment.id, true, true)) + "\u003E\u003Cspan class=\"icon icon-flag\"\u003E\u003C\u002Fspan\u003E&nbsp;";
if (comment.isFlaggedByLearner) {
pug_html = pug_html + (pug_escape(null == (pug_interp = i18n("social.reported")) ? "" : pug_interp));
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = i18n("social.report")) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fspan\u003E\u003Cspan class=\"comment-action comment-cancel icon icon-close\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cp class=\"block-md comment-message text-md\"\u003E";
if (isEmoji(comment.message)) {
pug_html = pug_html + "\u003Cspan class=\"emoji\"\u003E" + (pug_escape(null == (pug_interp = comment.message) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = comment.message) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fp\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
if (!peerAuthoring) {
if (isNoMoreComments) {
pug_html = pug_html + "\u003Cp class=\"text-muted text-center block-v-md\"\u003E" + (pug_escape(null == (pug_interp = i18n("social.thats-all")) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
}
else {
pug_html = pug_html + "\u003Cimg class=\"loader\" src=\"img\u002Ftemplates\u002Floader-light.gif\" width=\"32\"\u003E";
}
}
}
    }.call(this, "Date" in locals_for_with ?
        locals_for_with.Date :
        typeof Date !== 'undefined' ? Date : undefined, "comments" in locals_for_with ?
        locals_for_with.comments :
        typeof comments !== 'undefined' ? comments : undefined, "d1" in locals_for_with ?
        locals_for_with.d1 :
        typeof d1 !== 'undefined' ? d1 : undefined, "d2" in locals_for_with ?
        locals_for_with.d2 :
        typeof d2 !== 'undefined' ? d2 : undefined, "distance" in locals_for_with ?
        locals_for_with.distance :
        typeof distance !== 'undefined' ? distance : undefined, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "isEmoji" in locals_for_with ?
        locals_for_with.isEmoji :
        typeof isEmoji !== 'undefined' ? isEmoji : undefined, "isNoMoreComments" in locals_for_with ?
        locals_for_with.isNoMoreComments :
        typeof isNoMoreComments !== 'undefined' ? isNoMoreComments : undefined, "moment" in locals_for_with ?
        locals_for_with.moment :
        typeof moment !== 'undefined' ? moment : undefined, "peerAuthoring" in locals_for_with ?
        locals_for_with.peerAuthoring :
        typeof peerAuthoring !== 'undefined' ? peerAuthoring : undefined));
    ;;return pug_html;};module.exports=template;